import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useLocation } from "react-router-dom";
import Header from '../component/Header';
import config from '../config';
import NotFound from './NotFound'
import axios from "../service/axiosPhoneLookup";

const Home = (props) => {
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const token = params.get('token');
    const phoneNumber = params.get('phone_number');
    const maskedPhoneNumber = `(${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6, phoneNumber.length)}`;

    const [customers, setCustomers] = useState([]);
    const [isCustomerFound, setIsCustomerFound] = useState(true);
    const [isCustomerLoading, setIsCustomerLoading] = useState(true);
    const [selectedCustId, setSelectedCustId] = useState(0);
    const [plans, setPlans] = useState([]);
    const [isPlanLoading, setIsPlanLoading] = useState(true);
    const [selectedPlanId, setSelectedPlanId] = useState(0);
    const [claims, setClaims] = useState([]);
    const [isClaimLoading, setIsClaimLoading] = useState(true);
    const [selectedClaimId, setSelectedClaimId] = useState(0);

    useEffect(async () => {
        setIsCustomerLoading(true);
        setIsPlanLoading(true);
        setIsClaimLoading(true);

        let { data } = await axios.get(config.API_PATH_GET_CUSTOMER_BY_PHONE.replace('{phoneNumber}', maskedPhoneNumber));
        // console.log("customers:::", data);
        setCustomers(data?.result);
        setSelectedCustId(data?.result && data?.result.length > 0 ? data?.result[0].id : "");
        setIsCustomerFound(data && data?.result.length > 0)
        setIsCustomerLoading(false);
    }, []);

    useEffect(async () => {
        setIsPlanLoading(true);
        setIsClaimLoading(true);
        let { data } = await axios.get(config.API_PATH_GET_CUSTOMER_BY_CUST_ID.replace('{custId}', selectedCustId));
        // console.log("plans:::", data);
        setPlans(data?.result);
        setSelectedPlanId(data?.result && data?.result.length > 0 ? data?.result[0].Warr_ID : "");
        setIsPlanLoading(false);
    }, [selectedCustId]);

    useEffect(async () => {
        setIsClaimLoading(true);
        if (selectedCustId && selectedPlanId) {
            let { data } = await axios.get(config.API_PATH_GET_CUSTOMER_BY_CUST_WARR_ID.replace('{custId}', selectedCustId).replace('{warrId}', selectedPlanId));
            // console.log("claims:::", data);
            setClaims(data?.result);
            setSelectedClaimId(data?.result && data?.result.length > 0 ? data?.result[0].Claim_Id : "");
            setIsClaimLoading(false);
        } else {
            setClaims([]);
            setSelectedClaimId("");
            setIsClaimLoading(false);
        }

    }, [selectedPlanId]);

    function customerCard(customer) {
        return (
            <Card key={customer.id} className={selectedCustId == customer.id ? "active" : ""} onClick={() => { setSelectedCustId(customer.id); }}>
                <div className="media p-3">
                    <img src="/customer.png" alt="image" className="rounded-circle leftimg" />
                    <div className="media-body">
                        <h5>{customer.fname + " " + customer.lname} </h5>
                        <div className="icon-list">
                            <i className="fa fa-phone"></i>
                            <span>{customer.hphone || "Not Found"}</span>
                        </div>
                        <div className="icon-list">
                            <i className="fa fa-mobile"></i>
                            <span>{customer.cphone || "Not Found"}</span>
                        </div>
                        <div className="icon-list">
                            <i className="fa fa-envelope-o"></i>
                            <span>{customer.email || "Not Found"}</span>
                        </div>
                        <div className="icon-list">
                            <i className="fa fa-map-marker"></i>
                            <span>{(customer.street1_1 || "") + " " + (customer.city1 || "") + " " + (customer.state1 || "") + " " + (customer.zip1 || "")}</span>
                        </div>
                    </div>
                </div>
            </Card >
        )
    }

    function planCard(plan) {
        return (
            <Card key={plan.Warr_ID} className={selectedPlanId == plan.Warr_ID ? "active" : ""} onClick={() => { setSelectedPlanId(plan.Warr_ID) }}>
                <div className="media p-3">
                    <img src="/warranty.png" alt="image" className="rounded-circle leftimg" />
                    <div className="media-body">
                        <h5>{plan.Plan_Number}</h5>
                        <div className="info-list">
                            <small>Store</small>
                            <strong>{plan.Store || "Not Found"}</strong>
                        </div>
                        <div className="info-list">
                            <small>Manufacturer</small>
                            <strong>{plan.manufacturer || "Not Found"}</strong>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="info-list">
                                    <small>Purchase:</small>
                                    <strong>{plan.Purchase || "Not Found"} </strong>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="info-list">
                                    <small> Delivery:</small>
                                    <strong>{plan.Delivery || "Not Found"} </strong>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="info-list">
                                    <small>Invoice:</small>
                                    <strong>{plan.Invoice || "Not Found"} </strong>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="info-list">
                                    <small>Total Price:</small>
                                    <strong>{plan.Total_Price || "Not Found"} </strong>
                                </div>
                            </div>
                        </div>
                        <div className="info-list">
                            <strong className="text-primary">{plan.id} </strong>
                        </div>
                    </div>
                </div>
            </Card >
        )
    }

    function viewClaim(claimId) {
        window.open(config.CLAIM_REDIRECT_URL + claimId, "_blank")
    }

    function claimCard(claim) {
        return (
            <Card key={claim.Claim_Id} className={selectedClaimId == claim.Claim_Id ? "active" : ""} onClick={() => { setSelectedClaimId(claim.Claim_Id) }}>
                <div className="media p-3">
                    <img src="/insurance.png" alt="image" className="rounded-circle leftimg" />
                    <div className="media-body">
                        <div className="info-list">
                            <small>Claim ID </small>
                            <strong>{claim.Claim_Id || "Not Found"} </strong>
                        </div>
                        <div className="info-list">
                            <small>Status</small>
                            <strong>{claim.Status || "Not Found"} </strong>
                        </div>
                        <div className="info-list">
                            <small>Claim Date</small>
                            <strong>{claim.Claim_Date || "Not Found"}</strong>
                        </div>
                        <div className="cardaction">
                            <button className="btn btn-sm btn-primary" onClick={() => viewClaim(claim.Claim_Id)}>View Claim</button>
                        </div>
                    </div>
                </div>
            </Card >
        )
    }

    return (
        token == config.VALID_TOKEN && isCustomerFound ? <>
            <Header phoneNumber={maskedPhoneNumber} />
            <div className="page-wrapper">
                <div className="planstable">
                    <Container>
                        <Row>
                            <Col md={4} className="p-0">
                                <div className="colwrap">
                                    <h3 className="titles">Customer Records</h3>
                                    {isCustomerLoading ? <h5>{"Loading..."}</h5> : customers && customers?.length > 0 ? customers.map((customer) => {
                                        return customerCard(customer);
                                    }) : <h5>{"Customer Not Found"}</h5>}
                                </div>
                            </Col>
                            <Col md={4} className="p-0">
                                <div className="colwrap">
                                    <h3 className="titles">Customer Service Plans</h3>
                                    {isPlanLoading ? <h5>{"Loading..."}</h5> : plans && plans?.length > 0 ? plans.map((plan) => {
                                        return planCard(plan);
                                    }) : <h5>{"Plans Not Found"}</h5>}
                                </div>
                            </Col>
                            <Col md={4} className="p-0">
                                <div className="colwrap no-border">
                                    <h3 className="titles">Claims</h3>
                                    {isClaimLoading ? <h5>{"Loading..."}</h5> : claims && claims?.length > 0 ? claims.map((claim) => {
                                        return claimCard(claim);
                                    }) : <h5>{"Claims Not Found"}</h5>}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </> : <NotFound maskedPhoneNumber={maskedPhoneNumber} message={"No customers match the phone number provided."} />
    );
};

export default Home;